"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Modal/Modal/View.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
















const stopPropagation = e => e.stopPropagation()

const FOCUSABLE = 'button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
const focusableIn = (root) => [...root.querySelectorAll(FOCUSABLE)]
  .filter(el => _nullishCoalesce(_optionalChain([el, 'access', _ => _.checkVisibility, 'optionalCall', _2 => _2()]), () => ( true)))

const Modal = _react2.default.forwardRef(({
  isOpen,
  onClose,
  onEscape,
  title,
  ariaLabel,
  className,
  bodyClassName,
  size,
  fullScreen,
  children,
}, ref) => {
  // The dialog is named by its title, for assistive technology.
  const titleId = _react.useId.call(void 0, )
  _react.useEffect.call(void 0, 
    () => {
      const handleEsc = (e) => {
        if (e.keyCode !== 27 || !isOpen) return
        ;_optionalChain([(_nullishCoalesce(onEscape, () => ( onClose))), 'optionalCall', _3 => _3()])
        e.stopPropagation()
      }
      window.addEventListener('keyup', handleEsc)
      return () => window.removeEventListener('keyup', handleEsc)
    },
    [isOpen, onClose, onEscape],
  )

  // Focus moves to the dialog's first control as it opens, unless a field in
  // it already took it, and goes back to the control that opened it when it
  // closes. A field with autoFocus takes focus before any effect runs, so the
  // focus event that brought it in names the opener.
  const dialogRef = _react.useRef(null)
  const focusCameFromRef = _react.useRef(null)
  const handleFocus = _react.useCallback.call(void 0, (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) focusCameFromRef.current = e.relatedTarget
  }, [])
  _react.useEffect.call(void 0, 
    () => {
      if (!isOpen) return
      const dialog = dialogRef.current
      const focus = document.activeElement
      const opener = _optionalChain([dialog, 'optionalAccess', _4 => _4.contains, 'call', _5 => _5(focus)]) ? focusCameFromRef.current : focus
      if (dialog && !dialog.contains(focus)) _optionalChain([focusableIn, 'call', _6 => _6(dialog), 'access', _7 => _7[0], 'optionalAccess', _8 => _8.focus, 'call', _9 => _9()])
      return () => {
        const focus = document.activeElement
        const lostFocus = focus === document.body || !!_optionalChain([dialog, 'optionalAccess', _10 => _10.contains, 'call', _11 => _11(focus)])
        if (lostFocus && opener instanceof HTMLElement && opener.isConnected) opener.focus()
      }
    },
    [isOpen],
  )

  // Tab and Shift+Tab cycle through the dialog instead of the page behind it.
  const handleKeyDown = _react.useCallback.call(void 0, (e) => {
    if (e.key !== 'Tab') return
    const items = focusableIn(e.currentTarget)
    const first = items[0]
    const last = items[items.length - 1]
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault()
      _optionalChain([last, 'optionalAccess', _12 => _12.focus, 'call', _13 => _13()])
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault()
      _optionalChain([first, 'optionalAccess', _14 => _14.focus, 'call', _15 => _15()])
    }
  }, [])

  const isMouseDownOverBackdrop = _react.useRef.call(void 0, false)
  const handleBackdropClick = _react.useCallback.call(void 0, 
    (e) => {
      if (
        e.target === e.currentTarget
        && isMouseDownOverBackdrop.current
      ) _optionalChain([onClose, 'optionalCall', _16 => _16()])

      isMouseDownOverBackdrop.current = false
    },
    [onClose],
  )

  return (
    _react2.default.createElement('div', {
      ref: ref,
      onMouseDown: () => isMouseDownOverBackdrop.current = true,
      onClick: handleBackdropClick,
      className: _classBuilder2.default.call(void 0, 
        'blm-modal--backdrop',
        !isOpen && "blm-modal--backdrop--hidden",
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}

      , _react2.default.createElement('div', {
        ref: dialogRef,
        role: "dialog",
        onKeyDown: handleKeyDown,
        onFocus: handleFocus,
        'aria-label': title || ariaLabel || undefined,
        'aria-hidden': !isOpen,
        'aria-labelledby': title ? titleId : undefined,
        onMouseDown: stopPropagation,
        className: _classBuilder2.default.call(void 0, 
          "blm-modal",
          size && `blm-modal--${size}`,
          fullScreen && 'blm-modal--fullscreen',
          className,
        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}

        ,  title && (
          _react2.default.createElement('div', { className: "blm-modal--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
            , _react2.default.createElement('h3', { id: titleId, className: "blm-modal--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}},  title )
            ,  onClose && (
              _react2.default.createElement('button', {
                type: "button",
                'aria-label': "Close",
                onClick: onClose,
                className: "blm-modal--close-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}
              )
            )
          )
        )
        , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, "blm-modal--body", bodyClassName), __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}}
          ,  children 
        )
      )
    )
  )
})

Modal.displayName = 'Modal'

exports. default = Modal
